import { useEffect } from 'react';

const SEO = ({ title, description, keywords, currentUrl, type = "website", schema }) => {
  useEffect(() => {
    // 1. Sayfa Başlığı (Title)
    document.title = title ? `${title} | Diba Halı Yıkama` : "Diba Halı Yıkama - İstanbul Profesyonel Halı Temizlik Fabrikası";

    // Meta Tag'leri dinamik değiştirme yardımcı fonksiyonu
    const setMetaTag = (attrName, attrValue, content) => {
      if (!content) return;
      let element = document.querySelector(`meta[${attrName}="${attrValue}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attrName, attrValue);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // 2. Standart Meta Description ve Keywords
    setMetaTag('name', 'description', description || "Diba Halı Yıkama olarak İstanbul Avrupa yakasında Esenler, Bağcılar, Güngören, Bayrampaşa, Zeytinburnu başta olmak üzere profesyonel halı, koltuk, yatak ve stor perde yıkama hizmeti veriyoruz.");
    setMetaTag('name', 'keywords', keywords || "halı yıkama, koltuk yıkama, stor perde yıkama, istanbul halı yıkama, esenler halı yıkama, bağcılar halı yıkama, yatak temizleme");

    // 3. Open Graph (Sosyal Medya & WhatsApp Paylaşımları için)
    setMetaTag('property', 'og:title', title ? `${title} | Diba Halı Yıkama` : "Diba Halı Yıkama Profesyonel Kurumsal Hizmet");
    setMetaTag('property', 'og:description', description || "Avrupa yakasında 30 dakikada ücretsiz servis imkanıyla en temiz ve hijyenik halı yıkama hizmeti.");
    setMetaTag('property', 'og:type', type);
    setMetaTag('property', 'og:url', currentUrl || "https://dibahaliyikama.com");
    setMetaTag('property', 'og:image', "https://dibahaliyikama.com/logo512.png");
    setMetaTag('property', 'og:site_name', "Diba Halı Yıkama");
    setMetaTag('property', 'og:locale', "tr_TR");

    // 4. Canonical Link (Kopya İçerik Göreceliliğini Engellemek İçin)
    let link = document.querySelector(`link[rel="canonical"]`);
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', currentUrl || "https://dibahaliyikama.com");

    // 5. Schema JSON-LD Yapısal Veri (Google Zengin Sonuçlar İçin)
    let script = document.querySelector('#seo-structured-data');
    if (!script) {
      script = document.createElement('script');
      script.id = 'seo-structured-data';
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    
    // Temel LocalBusiness Şeması
    const baseSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Diba Halı Yıkama",
      "image": "https://dibahaliyikama.com/logo512.png",
      "@id": "https://dibahaliyikama.com",
      "url": "https://dibahaliyikama.com",
      "telephone": "+905555555555",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Esenler Merkez",
        "addressLocality": "Esenler",
        "addressRegion": "İstanbul",
        "postalCode": "34220",
        "addressCountry": "TR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 41.0366,
        "longitude": 28.8797
      },
      "areaServed": [
        {"@type": "City", "name": "Esenler"},
        {"@type": "City", "name": "Güngören"},
        {"@type": "City", "name": "Bağcılar"},
        {"@type": "City", "name": "Bayrampaşa"},
        {"@type": "City", "name": "Zeytinburnu"},
        {"@type": "City", "name": "Bahçelievler"}
      ],
      "priceRange": "₺₺",
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
        ],
        "opens": "08:00",
        "closes": "22:00"
      }
    };

    // Eğer sayfadan özel şema yollanmışsa array olarak bağla (Multi-schema)
    let finalSchema = schema ? [baseSchema, schema] : baseSchema;
    
    script.innerHTML = JSON.stringify(finalSchema);

  }, [title, description, keywords, currentUrl, type, schema]);

  return null;
};

export default SEO;